import { createContext } from 'react';
export var RendererContext = createContext();
export var ThemeContext = createContext();